import { prefixClassName } from 'framework/components/ui/_conf';
import { LayoutSelectionType } from 'framework/modules/contentmanagement/CmsComponents.interfaces';

export const CmsComponentModalClassName = 'cms-components-modal';
export const excludeOnRow: LayoutSelectionType[] = ['row', 'carousel', 'fullwidth', 'nonrow-selectable'];
export const carouselSelectables: LayoutSelectionType[] = ['carouselSelect'];

export const rootClass = prefixClassName(CmsComponentModalClassName);
